"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ApiKeyHandler = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactRouterDom = require("react-router-dom");
var _propTypes = _interopRequireDefault(require("prop-types"));
var _apiKeyManager = require("../../data/api/apiKeyManager");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && Object.prototype.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var ApiKeyHandler = exports.ApiKeyHandler = function ApiKeyHandler(_ref) {
  var apiKey = _ref.apiKey,
    clientId = _ref.clientId,
    children = _ref.children;
  var location = (0, _reactRouterDom.useLocation)();

  /* Reset api key on location change */
  (0, _react.useEffect)(function () {
    var keyManager = (0, _apiKeyManager.getApiKeyManager)(apiKey, clientId);
    if (!keyManager.isAuthenticated()) {
      keyManager.resetApiKeyExpiry();
    }
  }, [apiKey, clientId, location]);
  return /*#__PURE__*/_react["default"].createElement("div", null, children);
};
ApiKeyHandler.propTypes = {
  apiKey: _propTypes["default"].string,
  clientId: _propTypes["default"].string,
  children: _propTypes["default"].node
};